import {
  Backdrop,
  Box,
  Button,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import { useState } from "react";

import { dismissSystemNotification } from "@/services/app/index";
import { useAppStore } from "@/stores/appStore";

export const SystemNotificationOverlay = () => {
  const { user, systemNotifications } = useAppStore();
  const [allSystemNotifications, setAllSystemNotifications] =
    useState(systemNotifications);
  const [systemNotificationOpen, setSystemNotificationOpen] = useState(
    allSystemNotifications?.length > 0
  );

  const handleDismissSystemNotification = async (notification) => {
    const result = await dismissSystemNotification(notification, user.user_id);
    if (result) {
      setAllSystemNotifications((prevNotifications) => {
        const updatedNotifications = prevNotifications.filter(
          (n) => n.notification_name !== notification.notification_name
        );
        if (updatedNotifications.length === 0) {
          setSystemNotificationOpen(false);
        }
        return updatedNotifications;
      });
    }
  };

  const handleDismissAllSystemNotifications = async () => {
    await Promise.all(
      allSystemNotifications.map((notification) =>
        dismissSystemNotification(notification, user.user_id)
      )
    );
    setAllSystemNotifications([]);
    setSystemNotificationOpen(false);
  };

  return (
    <>
      <Backdrop
        open={systemNotificationOpen}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(0, 0, 0, 0.6)", // Darken background for better contrast
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            backgroundColor: "white",
            padding: 3,
            borderRadius: 2,
            boxShadow: 3,
            maxWidth: "50%",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            System Notifications
          </Typography>
          <Divider sx={{ width: "100%" }} />

          {allSystemNotifications?.map((notification, index) => (
            <Paper
              key={index}
              elevation={3}
              sx={{
                p: 2,
                mb: 2,
                mt:2,
                borderRadius: 2,
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ color: "#333", flexGrow: 1 }}
                  dangerouslySetInnerHTML={{
                    __html: notification.notification_text,
                  }}
                />
                <Button
                  onClick={() => handleDismissSystemNotification(notification)}
                  sx={{ fontSize: "0.8rem", ml: 2 }}
                  size="small"
                  color="primary"
                >
                  Dismiss
                </Button>
              </Box>
            </Paper>
          ))}

          {allSystemNotifications.length > 1 && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                onClick={handleDismissAllSystemNotifications}
                sx={{ mt: 2, fontWeight: "bold" }}
                variant="contained"
                color="primary"
              >
                DISMISS ALL
              </Button>
            </Box>
          )}
        </Box>
      </Backdrop>
    </>
  );
};
